<template>
  <svg
    id="Сгруппировать_3121"
    data-name="Сгруппировать 3121"
    xmlns="http://www.w3.org/2000/svg"
    width="53.347"
    height="41.335"
    viewBox="0 0 53.347 41.335"
  >
    <path
      id="_Compound_Path_"
      data-name=" Compound Path "
      d="M56.84,410.1v-2.746a1.6,1.6,0,0,0-1.693-1.739,1.8,1.8,0,0,0-1.556.778,1.6,1.6,0,0,0-1.465-.778,1.556,1.556,0,0,0-1.327.641v-.549h-.87V410.1h.87v-2.517a1.025,1.025,0,0,1,1.1-1.144c.641,0,1.007.412,1.007,1.144V410.1h.87v-2.517a1.025,1.025,0,0,1,1.1-1.144c.641,0,1.007.412,1.007,1.144V410.1Zm14.28-4.348h-1.6v-1.327h-.87v1.327h-.915v.778h.915v2.06c0,1.007.366,1.6,1.465,1.6a2.558,2.558,0,0,0,1.19-.32l-.275-.778a1.5,1.5,0,0,1-.824.229.64.64,0,0,1-.691-.586.627.627,0,0,1,0-.147v-2.105h1.6Zm8.147-.137a1.373,1.373,0,0,0-1.19.641v-.549h-.87V410.1h.87v-2.472c0-.732.366-1.19.961-1.19a2.7,2.7,0,0,1,.6.092l.275-.824A3.058,3.058,0,0,0,79.268,405.614Zm-12.312.458a3.14,3.14,0,0,0-1.785-.458c-1.1,0-1.785.5-1.785,1.373,0,.732.5,1.144,1.465,1.282l.458.046c.5.092.824.275.824.5,0,.32-.366.549-1.053.549a2.41,2.41,0,0,1-1.465-.458l-.458.687a3.317,3.317,0,0,0,1.877.549c1.282,0,1.968-.6,1.968-1.419s-.549-1.144-1.51-1.282l-.458-.046c-.412-.046-.778-.183-.778-.458s.366-.549.87-.549a3.3,3.3,0,0,1,1.373.366ZM80.275,407.9a2.16,2.16,0,0,0,2.289,2.289,2.288,2.288,0,0,0,1.556-.5L83.662,409a1.831,1.831,0,0,1-1.144.412,1.469,1.469,0,0,1,0-2.929,1.83,1.83,0,0,1,1.144.412l.458-.687a2.288,2.288,0,0,0-1.556-.5,2.05,2.05,0,0,0-2.289,2.2ZM74.1,405.614a2.1,2.1,0,0,0-2.151,2.288,2.151,2.151,0,0,0,2.243,2.289,2.8,2.8,0,0,0,1.785-.6l-.458-.641a2.189,2.189,0,0,1-1.282.458,1.286,1.286,0,0,1-1.327-1.144h3.25V407.9A2.062,2.062,0,0,0,74.1,405.614Zm0,.824a1.094,1.094,0,0,1,1.143,1.042c0,.019,0,.038,0,.056H72.86A1.176,1.176,0,0,1,74.1,406.438ZM62.241,407.9v-2.2h-.87v.549a1.684,1.684,0,0,0-1.419-.641,2.289,2.289,0,0,0,0,4.577,1.684,1.684,0,0,0,1.419-.641v.549h.87Zm-3.57,0a1.373,1.373,0,1,1,1.373,1.465,1.346,1.346,0,0,1-1.378-1.313A1.3,1.3,0,0,1,58.671,407.9ZM92.5,405.614a1.373,1.373,0,0,0-1.19.641v-.549h-.87V410.1h.87v-2.472c0-.732.366-1.19.961-1.19a2.7,2.7,0,0,1,.6.092l.275-.824A3.058,3.058,0,0,0,92.5,405.614ZM89.108,407.9v-2.2h-.87v.549a1.684,1.684,0,0,0-1.419-.641,2.289,2.289,0,0,0,0,4.577,1.684,1.684,0,0,0,1.419-.641v.549h.87Zm-3.524,0a1.373,1.373,0,1,1,1.373,1.465A1.323,1.323,0,0,1,85.584,407.9Zm12.4,0v-3.936h-.87v2.288a1.684,1.684,0,0,0-1.419-.641,2.289,2.289,0,0,0,0,4.577,1.684,1.684,0,0,0,1.419-.641v.549h.87Zm-3.57,0a1.373,1.373,0,1,1,1.373,1.465,1.346,1.346,0,0,1-1.378-1.313A1.3,1.3,0,0,1,94.418,407.9Z"
      transform="translate(-47.112 -368.859)"
    />
    <g id="_Group_" data-name=" Group ">
      <rect
        id="Прямоугольник_107"
        data-name="Прямоугольник 107"
        width="15.882"
        height="25.906"
        transform="translate(18.744 3.525)"
        fill="#ff5f00"
      />
      <path
        id="_Path_"
        data-name=" Path "
        d="M64.368,343.742a16.522,16.522,0,0,1,6.271-12.953,16.477,16.477,0,1,0,0,25.906A16.523,16.523,0,0,1,64.368,343.742Z"
        transform="translate(-43.976 -327.264)"
        fill="#eb001b"
      />
      <path
        id="Контур_1136"
        data-name="Контур 1136"
        d="M128.967,343.764a16.477,16.477,0,0,1-26.638,12.953,16.514,16.514,0,0,0,0-25.906,16.477,16.477,0,0,1,26.638,12.953Z"
        transform="translate(-75.621 -327.286)"
        fill="#f79e1b"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'Icon',
  }
</script>
